<template>
  <div class="cpt-header">
    <!-- 移动端 -->
      <div class="mobile-header" v-if="userAgent">
        <div @click="drawer = true" class="header-button">
          <img src="../../assets/mobile-icon2.png" alt="">
        </div>
        <div class="logo" @click="toHome">
          <img class="logo-img" src="../../assets/logo.png" alt="">
        </div>
        <div class="header-button">
          <!-- <img src="../../assets/mobile-icon1.png" alt=""> -->
        </div>
      </div>
      <van-popup v-model="drawer" position="left" class="popup-style">
        <div
          v-for="item in navData"
          :key="item.id"
          :index="item.key"
          class="item"
          @click="handleSelect(item)"
        >
          {{ item.name }}
        </div>
      </van-popup>
    <!-- PC端 -->
    <div class="pc-header" v-if="!userAgent">
      <div class="logo" @click="toHome">
        <img src="../../assets/logo.png" alt="">
      </div>
      <div class="nav-list">
        <div
          v-for="item in navData"
          :key="item.id"
          :index="item.key"
          @click="handleSelect(item)"
          class="item"
          :class="activeIndex === item.key ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cpt-header",
  data() {
    return {
      userAgent: this.$utils.isMobile(),
      drawer: false,
      navData: this._contentData.navData,
      activeIndex: '1'
    };
  },
  mounted() {
    let path = this.$route.path
    if (path == '/index') {
      this.activeIndex = '1'
    } else if (path == '/about') {
      this.activeIndex = '2'
    } else if (path == '/service') {
      this.activeIndex = '3'
    // } else if (path == '/news') {
    //   this.activeIndex = '4'
    }
  },
  methods: {
    handleSelect(item) {
      if (!item.external) {
        this.activeIndex = item.key
        this.$router.push({
          path: item.href
        })
      } else {
        window.open(item.href, '_blank')
      }
    },
    toHome() {
      this.$router.push({
        path: '/index'
      })
    }
  },
};
</script>

<style lang='scss' scoped>
.cpt-header {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .mobile-header {
    background-color: #FFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    width: 100%;
    .logo{
      .logo-img{
        height: 35px;
      }
    }
    .header-button {
      margin: 0px 15px;
      background-color: #fff;
      // padding: 0px 5px;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      img {
        width: 30px;
      }
    }
  }
  .popup-style {
    height: 100%;
    width: 60%;
    padding: 0 20px;
    .item{
      padding: 15px;
      border-bottom: 1px solid rgba(51, 51, 51, 0.3);
    }
  }
  .pc-header {
    width: 1200px;
    height: 90px;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    font-size: 22px;
    .logo{
      // width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img{
        height: calc(100% - 40px);
      }
    }
    .nav-list{
      // width: 50%;
      height: calc(100% - 2px);
      display: flex;
      flex-direction: row;
      .item{
        // width: 120px;
        text-align: center;
        border-bottom: 2px solid transparent;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0 20px;
        &:hover {
          color: #407EA0;
          background: rgba(64, 127, 160, .1);
        }
      }
      .active{
        color: #407EA0;
        border-color: #407EA0;
        background: rgba(64, 127, 160, .1);
      }
    }
  }
}
</style>